import React, { useEffect, useState, createElement } from 'react';
import { Ticket, X, User, Mail, Phone, Globe, Check, AlertCircle, BookOpen, Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function OptinVslPage() {
  // Modal State (only for legal pages now)
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Form State
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Load Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init + PageView handled globally in App.tsx — removed here
    // to avoid double-counting.
  }, []);
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !name || !phone || isSubmitting) return;
    setIsSubmitting(true);
    try {
      await fetch('https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/d1eada12-31ca-46fe-a334-a8ceb1286952', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email,
          areaCode,
          phoneNumber: phone,
          fullPhone: `${areaCode}${phone}`,
          source: 'optin-vsl'
        })
      });
      // Redirect to VSL page after opt-in
      navigate('/vsl');
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-[#050505] text-white font-sans selection:bg-[#FDB931] selection:text-black overflow-x-hidden" data-id="element-4059" data-mp="36t80mlx8lnsp">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4060" data-mp="2x4gckovarnn2">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4061" data-mp="2x3y66zex7t1f" />
      </noscript>

      {/* Ambient Background Effects */}
      <div className="fixed inset-0 pointer-events-none z-0" data-id="element-4062" data-mp="2o4t8fvb6o3qb">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#FDB931]/5 rounded-full blur-[120px]" data-id="element-4063" data-mp="2s4lmuon9d43l" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#FDB931]/5 rounded-full blur-[120px]" data-id="element-4064" data-mp="2e52fhy29twsc" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 brightness-100 contrast-150 mix-blend-overlay" data-id="element-4065" data-mp="2j340ioj9c66g"></div>
      </div>

      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-16 min-h-screen flex flex-col justify-center" data-id="element-4066" data-mp="3hfzt43vk4ar9">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-4067" data-mp="3cnos0xp2yix4">
          {/* LEFT COLUMN: Copy & Value Prop */}
          <div className="lg:col-span-7 space-y-8 text-left animate-in fade-in slide-in-from-bottom-8 duration-700" data-id="element-4068" data-mp="37olurzfcdgzp">
            {/* Tagline */}
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-4069" data-mp="2xr7ga5czb2a1">
              <span className="relative flex h-2 w-2" data-id="element-4070" data-mp="2tsrnfku7uzop">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FDB931] opacity-75" data-id="element-4071" data-mp="2osc7qmmgpg3k"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FDB931]" data-id="element-4072" data-mp="rysev78hawfp"></span>
              </span>
              <span className="text-xs font-bold tracking-wider text-[#FDB931] uppercase" data-id="element-4073" data-mp="my4n2jcfebkf">
                Entrenamiento On-Demand · ~20 min
              </span>
            </div>

            {/* Headlines */}
            <div className="space-y-4" data-id="element-4074" data-mp="zggsx8muj85u">
              <h2 className="text-lg md:text-xl font-medium text-gray-400 leading-tight" data-id="element-4075" data-mp="1499wvuahqcgv">
                Descubre por qué el problema no es la falta de ideas o
                herramientas...
              </h2>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.95] text-white" data-id="element-4076" data-mp="blw4m9hqm533">
                El error que hace que los productos con IA{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FDB931] to-[#FFD700]" data-id="element-4077" data-mp="lhz8bjs8mbs5">
                  fallen antes de vender
                </span>
              </h1>
            </div>

            {/* Value Bullets */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-4078" data-mp="1x0a1a6cqhi92">
              <div className="flex items-center gap-3 mb-6" data-id="element-4079" data-mp="211n8ajrkbrhk">
                <AlertCircle className="text-[#FDB931] w-5 h-5" data-id="element-4080" data-mp="1tpt6spaj8pl" />
                <p className="font-bold text-white text-sm md:text-base" data-id="element-4081" data-mp="3t1vahpumndeo">
                  Lo que descubrirás en esta sesión:
                </p>
              </div>
              <ul className="space-y-4" data-id="element-4082" data-mp="atmld4aw2ppe">
                {['Por qué el contenido bueno NO garantiza ventas', 'El error silencioso que mata la conversión al inicio', 'Qué debe estar claro antes de usar cualquier IA'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300 text-sm md:text-base" data-id="element-4083" data-mp="3aaubj1tibhv4" data-mpi={i}>
                    <Check className="w-5 h-5 text-[#FDB931] shrink-0 mt-0.5" data-id="element-4084" data-mp="3o1z6vrpudnzn" />
                    <span data-id="element-4085" data-mp="3o43lb3lda5e6">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Bonus/Gift Tease */}
            <div className="flex items-center gap-4 p-4 rounded-xl bg-gradient-to-r from-gray-900 to-transparent border-l-4 border-[#FDB931]" data-id="element-4086" data-mp="2vlg1dri3wweo">
              <div className="bg-[#FDB931]/10 p-2 rounded-lg shrink-0" data-id="element-4087" data-mp="2qmlby6pmw9ll">
                <BookOpen className="w-5 h-5 text-[#FDB931]" data-id="element-4088" data-mp="163rjtmwgv5i0" />
              </div>
              <div data-id="element-4089" data-mp="1aw2i6lbk6j8g">
                <p className="text-[#FDB931] font-bold text-sm uppercase" data-id="element-4090" data-mp="1awcdmofdhilj">
                  Incluye Regalo Exclusivo
                </p>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-4091" data-mp="x2balihe19fd">
                  Guía PDF: "Antes de Construir Cualquier Producto"
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: Inline Form */}
          <div className="lg:col-span-5 w-full animate-in fade-in slide-in-from-bottom-12 duration-1000 delay-200" data-id="element-4092" data-mp="1ttdk6dokrqrl">
            <div className="bg-[#111] border border-white/10 rounded-3xl p-6 md:p-8 shadow-2xl shadow-black/50 relative overflow-hidden group" data-id="element-4093" data-mp="1ftufjuuz2xk1">
              {/* Subtle Glow Effect on Form */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-[#FDB931] to-transparent opacity-50 blur-sm" data-id="element-4094" data-mp="4ep8kent6cum"></div>

              <div className="text-center mb-8" data-id="element-4095" data-mp="112o34fz0936k">
                <h3 className="text-2xl font-black text-white uppercase mb-2" data-id="element-4096" data-mp="113fzht0ff4xw">
                  Acceso Inmediato
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-4097" data-mp="r3p29jkhebu4">
                  Completa tus datos para desbloquear el entrenamiento.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-4098" data-mp="m6ozbhixhp78">
                {/* Name */}
                <div className="space-y-1.5" data-id="element-4099" data-mp="1jrumm57mhytf">
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-4100" data-mp="1eszxklj2be0v">
                    Nombre
                  </label>
                  <div className="relative group/input" data-id="element-4101" data-mp="1a0qadd9c0s2a">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-4102" data-mp="152osgvnn6yse">
                      <User className="h-5 w-5 text-gray-500 group-focus-within/input:text-[#FDB931] transition-colors" data-id="element-4103" data-mp="22jvw01i0x7h3" />
                    </div>
                    <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre completo" required className="w-full pl-12 pr-4 py-4 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all font-medium" data-id="element-4104" data-mp="1xqkody5e0mo4" />
                  </div>
                </div>

                {/* Email */}
                <div className="space-y-1.5" data-id="element-4105" data-mp="2oz4aqxm98s7l">
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-4106" data-mp="2oy2vsi24blkl">
                    Email
                  </label>
                  <div className="relative group/input" data-id="element-4107" data-mp="2xtilqnzr5gkw">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-4108" data-mp="32r0xsn92gbx4">
                      <Mail className="h-5 w-5 text-gray-500 group-focus-within/input:text-[#FDB931] transition-colors" data-id="element-4109" data-mp="37qx3qs1bqdfb" />
                    </div>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" required className="w-full pl-12 pr-4 py-4 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all font-medium" data-id="element-4110" data-mp="3cpq73rmwco1r" />
                  </div>
                </div>

                {/* Phone */}
                <div className="space-y-1.5" data-id="element-4111" data-mp="2kkxoztef1l5e">
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-4112" data-mp="2kk5tsjoqdpfn">
                    WhatsApp
                  </label>
                  <div className="flex gap-3" data-id="element-4113" data-mp="2tkud9tww8hzx">
                    <div className="relative w-[35%] group/input" data-id="element-4114" data-mp="2tm5ble7kkxjn">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-4115" data-mp="2yjdz7ubhltsa">
                        <Globe className="h-4 w-4 text-gray-500 group-focus-within/input:text-[#FDB931]" data-id="element-4116" data-mp="z8mj4isec557" />
                      </div>
                      <select value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-9 pr-2 py-4 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all appearance-none text-sm font-medium cursor-pointer" data-id="element-4117" data-mp="1488z2zzlzzhp">
                        {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900 text-white" data-id="element-4118" data-mp="hztrnm404gmc">
                            {country.code}
                          </option>)}
                      </select>
                    </div>
                    <div className="relative w-[65%] group/input" data-id="element-4119" data-mp="15nbdz24hymhx">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-4120" data-mp="15po25x0ult3f">
                        <Phone className="h-5 w-5 text-gray-500 group-focus-within/input:text-[#FDB931] transition-colors" data-id="element-4121" data-mp="11oc8ngeusnpy" />
                      </div>
                      <input type="tel" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required className="w-full pl-12 pr-4 py-4 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all font-medium" data-id="element-4122" data-mp="3mb5t2f2x42yy" />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button type="submit" disabled={isSubmitting} className="group relative w-full bg-[#FDB931] hover:bg-[#E6A02E] text-black font-black uppercase tracking-wide rounded-xl py-4 mt-4 shadow-[0_0_20px_rgba(253,185,49,0.2)] hover:shadow-[0_0_30px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none overflow-hidden" data-id="element-4123" data-mp="351v30f4e1o50">
                  <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-4124" data-mp="2m4tvonnd3bxw">
                    {isSubmitting ? 'Procesando...' : 'Ver Entrenamiento Ahora'}
                    {!isSubmitting && <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-4125" data-mp="27hv66y82erlt" />}
                  </span>

                  {/* Shine Effect */}
                  <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 group-hover:animate-shine" data-id="element-4126" data-mp="2gi9ve8o5gqul" />
                </button>

                <div className="flex items-center justify-center gap-2 text-[10px] text-gray-500" data-id="element-4127" data-mp="2qf5uxow2m2n0">
                  <Lock className="w-3 h-3" data-id="element-4128" data-mp="2lg1o34wmcgzu" />
                  <span data-id="element-4129" data-mp="2lfa0ag99jnk4">Tus datos están 100% seguros y protegidos.</span>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-16 lg:mt-24 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-[10px] text-gray-600" data-id="element-4130" data-mp="2v90mfehx3lwn">
          <p data-id="element-4131" data-mp="348ne38kuhdci">&copy; 2025 48 Hrs AI Cash Machine.</p>
          <div className="flex items-center gap-6" data-id="element-4132" data-mp="345rg5k8zyoo2">
            <button onClick={() => setShowTerms(true)} className="hover:text-gray-400 transition-colors" data-id="element-4133" data-mp="3o8nj85iduuw3">
              Términos
            </button>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-gray-400 transition-colors" data-id="element-4134" data-mp="wmm10bur04i">
              Privacidad
            </button>
            <a href="mailto:support@truemarketer.com" className="hover:text-gray-400 transition-colors" data-id="element-4135" data-mp="5ueepwkbmq9r">
              Soporte
            </a>
          </div>
        </div>
      </main>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-4136" data-mp="39eiqltnrzunn">
          <div className="bg-[#111] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-4137" data-mp="3jb5d0mvr2trs">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-4138" data-mp="yk4u08xovy7g">
              <X className="w-6 h-6" data-id="element-4139" data-mp="2j14bq8d7osl7" />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-white" data-id="element-4140" data-mp="2e3m5ipqkwrgw">
              Términos y Condiciones
            </h2>
            <div className="text-gray-400 text-sm space-y-4 leading-relaxed" data-id="element-4141" data-mp="29buj8regh7wk">
              <p data-id="element-4142" data-mp="24dt0y8outcm5">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos:
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-4143" data-mp="209l6duvpt2g0">1. Uso Educativo</h3>
              <p data-id="element-4144" data-mp="1vb9znt0pv820">
                El contenido es solo para fines educativos. No garantizamos
                resultados específicos.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-4145" data-mp="1lf6wcju4p3dh">
                2. Propiedad Intelectual
              </h3>
              <p data-id="element-4146" data-mp="3ks15ypdkz3a1">
                Todo el material es propiedad de 48 Hrs AI Cash Machine.
                Prohibida su reproducción.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-4147" data-mp="3fqvf6x3hdq35">3. Responsabilidad</h3>
              <p data-id="element-4148" data-mp="1e27n9n64w2kb">
                No somos responsables de decisiones comerciales tomadas basadas
                en esta información.
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-4149" data-mp="19464l3cme59d">
          <div className="bg-[#111] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-4150" data-mp="1wujna39berra">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-4151" data-mp="1nsk4p6injfm8">
              <X className="w-6 h-6" data-id="element-4152" data-mp="1rwru75wxozli" />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-white" data-id="element-4153" data-mp="cddklumkft2b">
              Política de Privacidad
            </h2>
            <div className="text-gray-400 text-sm space-y-4 leading-relaxed" data-id="element-4154" data-mp="gh3b4pmswkpz">
              <p data-id="element-4155" data-mp="8uxzwwzbtd77">En 48 Hrs AI Cash Machine protegemos tu información:</p>
              <h3 className="text-white font-bold mt-4" data-id="element-4156" data-mp="3xxv0pe7qgho">1. Recopilación</h3>
              <p data-id="element-4157" data-mp="iuf93odse97x">
                Solo recopilamos los datos necesarios para brindarte acceso al
                entrenamiento.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-4158" data-mp="dwndaja0u2yg">2. Uso</h3>
              <p data-id="element-4159" data-mp="3mam8hip65kaw">
                Usamos tus datos para enviarte el material prometido y
                comunicaciones relevantes.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-4160" data-mp="3hdvt6xl6usqj">3. No Spam</h3>
              <p data-id="element-4161" data-mp="3w20dg5zw3cbf">No vendemos ni compartimos tu información con terceros.</p>
            </div>
          </div>
        </div>}
    </div>;
}